import Message from './message';

export default Message;
